export const isLiquorOrderPlaceReady = (order) =>
  order?.status === "APPROVED" &&
  ((order.paymentMethod === "CASH" && order.paymentStatus === "CASH_DUE") ||
    (order.paymentMethod === "BANK_TRANSFER" && order.paymentStatus === "TRANSFER_CONFIRMED"));

export const getLiquorOrderWorkflowState = (order = {}) => {
  const status = order.status;
  if (status === "DRAFT") return {
    statusLabel: "Draft", statusTone: "neutral",
    nextStep: "Complete the order and submit it for approval.",
    primaryActionLabel: "Continue Order", actionType: "edit", canAct: true,
  };
  if (status === "CHANGES_REQUESTED") return {
    statusLabel: "Changes Requested", statusTone: "warning",
    nextStep: "Review Admin feedback, update the order and submit it again.",
    primaryActionLabel: "Review Changes", actionType: "edit", canAct: true,
  };
  if (status === "PENDING_APPROVAL") return {
    statusLabel: "Waiting for Approval", statusTone: "info",
    nextStep: "No action is required from you. Wait for Admin approval.",
    primaryActionLabel: "View Order", actionType: "view", canAct: false,
  };
  if (status === "APPROVED" && isLiquorOrderPlaceReady(order)) return {
    statusLabel: "Approved", statusTone: "success",
    nextStep: "The order is approved. Place it with the supplier.",
    primaryActionLabel: "Place Order", actionType: "place", canAct: true,
  };
  if (status === "APPROVED") return {
    statusLabel: "Approved", statusTone: "success",
    nextStep: order.paymentMethod === "BANK_TRANSFER"
      ? "Waiting for payment confirmation before the order can be placed."
      : "The order is approved. Review its payment status before placing it.",
    primaryActionLabel: "View Order", actionType: "view", canAct: false,
  };
  if (status === "PLACED") return {
    statusLabel: "Ordered from Supplier", statusTone: "info",
    nextStep: "When the delivery arrives, receive it through Stock Management.",
    primaryActionLabel: "Receive Stock", actionType: "receive", canAct: true,
  };
  if (status === "RECEIVED") return {
    statusLabel: "Stock Received", statusTone: "success",
    nextStep: "Completed. Stock has already been added.",
    primaryActionLabel: "View Details", actionType: "view", canAct: false,
  };
  if (status === "REJECTED") return {
    statusLabel: "Rejected", statusTone: "danger",
    nextStep: "This order was rejected. Review the reason.",
    primaryActionLabel: "View Details", actionType: "view", canAct: false,
  };
  return {
    statusLabel: "Order Update", statusTone: "neutral",
    nextStep: "Open the order to review its latest details.",
    primaryActionLabel: "View Order", actionType: "view", canAct: false,
  };
};

export const workflowToneClasses = {
  neutral: "border-slate-200 bg-slate-100 text-slate-700",
  info: "border-sky-200 bg-sky-50 text-sky-800",
  warning: "border-amber-200 bg-amber-50 text-amber-900",
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
  danger: "border-rose-200 bg-rose-50 text-rose-800",
};

export const getOrderManagerActionHref = (order, actionType) => {
  if (actionType === "edit") return `/order-manager/liquor-orders/${order.id}`;
  if (actionType === "receive") return `/order-manager/order-stocks?orderId=${order.id}`;
  return `/order-manager/liquor-orders/${order.id}`;
};
